import React from 'react';
import { Link, useLocation } from 'react-router-dom';
function Footer() {
  const location = useLocation();
  const currentPath = (location?.pathname || '').replace(/[^a-zA-Z0-9]/g, '_') || 'root';
  const currentYear = new Date().getFullYear();
  return <footer className="bg-sage-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-4">
              HopefulPaths
            </h3>
            <p className="text-sage-200 leading-relaxed mb-6 max-w-md">
              In-person therapy in Redwood City serving the South Bay, and online therapy throughout California. Helping women break free from people-pleasing and live, love, and lead authentically.
            </p>
            <div className="space-y-1 text-sage-200">
              <p className="font-semibold text-white">Yasi Philipos</p>
              <p>Licensed Marriage & Family Therapist #105168</p>
              <p>Founder, HopefulPaths</p>
              <p>Founder, The Compassionate Connect Method</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-e41765f244ff25fb_${currentPath}`}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/my-approach" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-6c2ad9317e7f45f5_${currentPath}`}>
                  About
                </Link>
              </li>
              <li>
                <a href="#services" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-3496e30fb7cd2c54_${currentPath}`}>
                  Services
                </a>
              </li>
              <li>
                <Link to="/testimonials" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-96e64750faa5b5f8_${currentPath}`}>
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-1cdfb21078b0c4b6_${currentPath}`}>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-11169ad65cd8ceef_${currentPath}`}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Services */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4">Services</h4>
            <ul className="space-y-3 mb-6">
              <li>
                <Link to="/services/individual-sessions" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-fc5ee298444cc40d_${currentPath}`}><span>
                  – Individual Therapy
                </span></Link>
              </li>
              <li>
                <Link to="/services/group-coaching" className="text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-3b69d01a2e052f70_${currentPath}`}><span>
                  – Group Coaching
                </span></Link>
              </li>
            </ul>

            <h4 className="text-lg font-serif font-semibold mb-4">Let's Connect!</h4>
            <div className="space-y-3">
              <a href="https://www.instagram.com/yasiphilipos/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sage-200 hover:text-warm-400 transition-colors" data-tracking-id={`link-bb0a8c42c4b6b148_${currentPath}`}>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
                Instagram
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-sage-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sage-300 text-sm">
            <p>
              © {currentYear} HopefulPaths Trauma Therapy and Coaching. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-warm-400 transition-colors" data-tracking-id={`link-88404a18332c6d9f_${currentPath}`}><span>
                Privacy Policy
              </span></Link>
              <Link to="/terms-conditions" className="hover:text-warm-400 transition-colors" data-tracking-id={`link-983758df3ba4ab55_${currentPath}`}><span>
                Terms & Conditions
              </span></Link>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <a href="#home" className="fixed bottom-8 right-8 w-12 h-12 bg-warm-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-warm-600 transition-all duration-300 hover:scale-110 z-40" aria-label="Back to top" data-tracking-id={`link-6ef2a91190c88e7b_${currentPath}`}>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </a>
    </footer>;
}
export default Footer;